// extracted by mini-css-extract-plugin
export default {"main":"NavStyle_main__XA-3D","point":"NavStyle_point__xWAmK","name":"NavStyle_name__3P0T7","active":"NavStyle_active__KlKAY"};